import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControl, Stack, MenuItem, Snackbar } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { useState } from 'react'
import { Zone } from "../../features/db/zone";

export default function NewZoneDialog(props) {
	const { variant } = props;
	const { submitCallback } = props;
	const { projects = [] } = props;

	const limit = 10;

	const [open, setOpen] = useState(false);
	const handleClick = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setNames([""]);
		setOpen(false);
	};

	const [names, setNames] = useState([""]);
	const handleNameChange = (e) => {
		let tempnames = names;
		let idx = parseInt(e.target.name);
		tempnames[idx] = e.target.value;
		setNames(tempnames);
	}

	const addZone = () => {
		if (names.length < limit) {
			setNames([...names, ""]);
		}
	}

	const [errorReason, setErrorReason] = useState("");
	const [openErrorSnack, setOpenErrorSnack] = useState(false);
	const handleErrorSnackClose = () => {
		setErrorReason("");
		setOpenErrorSnack(false);
	}

	const makeError = (reason) => {
		setErrorReason(reason);
		setOpenErrorSnack(true);
	}

	const handleSubmit=()=>
	{
		let count = 0;
		names.forEach((name)=>{if(name.includes("/")){count++;}});
		if(count > 0)
		{
			makeError("ZONE CANNOT CONTAIN / !");
			return;
		}
		if(project!=="")
		{
			let zones = [];
			names.forEach(
				(name,idx)=>{
					if(name!=="")
					{
						const z = new Zone(name,project);
						zones.push(z);
						z.submitAsNew();
					}
				}
			);
			if (zones.length < 1) {
				makeError("NO ZONES ENTERED!");
				return;
			}
			submitCallback(zones);
			handleClose();
			return;
		}
		makeError("NO PROJECT SELECTED!");
	}

	const [project, setProject] = useState("");
	const handleProjectChange = (e) => {
		setProject(e.target.value);
	};

	return (
		<>
			<Button onClick={handleClick} variant={variant}>New Zone</Button>
			<Snackbar open={openErrorSnack} autoHideDuration={5000} onClose={handleErrorSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
				<MuiAlert variant="filled" severity="error">
					{errorReason}
				</MuiAlert>
			</Snackbar>
			<Dialog onClose={handleClose} open={open}>
				<DialogTitle>Create A New Zone</DialogTitle>
				<DialogContent>
					<FormControl>
						<Stack spacing={{ xs: 1, sm: 2, md: 4 }} justifyContent="center">
							<br />
							<TextField select label={"Project"} value={project} onChange={handleProjectChange}>
								{
									projects.map((project, idx) => <MenuItem key={idx} value={project.id}>{project.id}</MenuItem>)
								}
							</TextField>
							<Box sx={{flexWrap: "wrap", display:"flex", justifyContent: 'center'}}>
								{names.map((name,idx)=>{
									return(
										<TextField
											autoFocus
											margin="dense"
											label={`Zone ${idx+1}`}
											variant="outlined"
											onChange={handleNameChange}
											key={""+idx}
											name={""+idx}
											sx={{m:1}}
										/>
									);
								})}
							</Box>
							{/* <Box sx={{ display: "flex", justifyContent: 'center', flexDirection: "column" }}>
								{names.map((name, idx) => {
									return (
										<Box style={{ marginTop: "5px" }}>
											<TextField
												style={{ margin: "0px", padding: "0px" }}
												autoFocus
												margin="dense"
												label={`Zone ${idx + 1}`}
												variant="outlined"
												onChange={handleNameChange}
												key={"" + idx}
												name={"" + idx}
												sx={{ m: 1 }}
											/>
										</Box>
									);
								})}
							</Box> */}
							<Button variant="outlined" onClick={addZone}>Add Zone</Button>
						</Stack>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>Cancel</Button>
					<Button onClick={handleSubmit} variant='contained'>Submit</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}